import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { GRID } from '../../constants';

var pageStyles = function pageStyles(maxWidth) {
  return facepaintMediaQueries({
    boxSizing: 'content-box',
    margin: '0 auto',
    maxWidth: maxWidth,
    padding: [0, "0 " + GRID.small, "0 " + GRID.medium, "0 " + GRID.large]
  });
};

export var NarrowPage = function NarrowPage(_a) {
  var children = _a.children,
      className = _a.className;
  return jsx("div", {
    css: pageStyles(840),
    className: className
  }, children);
};
export var MediumPage = function MediumPage(_a) {
  var children = _a.children,
      className = _a.className;
  return jsx("div", {
    css: pageStyles(1136),
    className: className
  }, children);
};
export var WidePage = function WidePage(_a) {
  var children = _a.children,
      className = _a.className;
  return jsx("div", {
    css: pageStyles(1440),
    className: className
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageLayouts/index.js
// module id = 805
// module chunks = 0